<table class="offer-presentation">
    <tbody>
    <tr>
        <td class="table-td-title"> {{ title }}</td>
        <ng-container *ngIf="groupCollapsed">
            <td class="text-blue text-center" *ngFor="let offer of offers"><span class="material-icons icon-none">—</span></td>
        </ng-container>
        <td *ngIf="!groupCollapsed" class="text-blue text-center "></td>
    </tr>
    <ng-container *ngIf="!groupCollapsed">
        <tr *ngFor="let coverage of groupOffer.coverages">
            <td class="offer-presentation__main-row offer-presentation__row">
        <span class="offer-presentation__main-row-item td-with-tooltip">
            {{getTranslationForParameter(coverage.labels, 'label')}}
            <app-tooltip-icon class="reset-position"
                            *ngIf="getTooltipTranslation(coverage.labels)"
                              [outlined]="isNext"
                            [description]="getTooltipTranslation(coverage.labels)">
        </app-tooltip-icon>
        </span>
            </td>
            <td class="text-blue text-center offer-presentation__row"
                *ngFor="let offer of offers">
                <app-offer-compare-box class="col-33 offer-compare-box"
                                    [box]="findCoverage(offer.coverages, coverage.code)"
                                    [coverageCode]="coverage.code">
                </app-offer-compare-box>
            </td>
        </tr>
    </ng-container>
    </tbody>
</table>
